import * as React from 'react';
import { cn } from '@/lib/utils';

const Disclaimer = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'flex w-full cursor-pointer items-center gap-2 rounded-[10px] border border-solid border-[#FF4C6F] bg-white p-2.5 px-5',
      'leading-[1.2] text-[#FD6B62] transition-shadow duration-150',
      'hover:shadow-[0px_4px_10px_3px_rgba(93,106,134,0.2)]',
      'focus:shadow-[0px_4px_10px_3px_rgba(93,106,134,0.2)]',
      className
    )}
    tabIndex={0} // Adicionado tabIndex para garantir que a div seja focável
    {...props}
  />
));
Disclaimer.displayName = 'Disclaimer';

const DisclaimerTitle = React.forwardRef(({ className, ...props }, ref) => (
  <h3
    ref={ref}
    className={cn('mb-0 w-full truncate text-sm font-bold leading-tight text-danger', className)}
    {...props}
  />
));
DisclaimerTitle.displayName = 'DisclaimerTitle';

// Este componente aceita um ícone como children
const DisclaimerIcon = React.forwardRef(({ className, children, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('flex h-[34px] w-[34px] flex-shrink-0 items-center justify-center rounded-full border border-solid border-[#ECE9F8]', 'bg-white text-[#FD6B62] shadow-[0px_4px_10px_3px_rgba(93,106,134,0.1)]', className)}
    {...props}
  >
    {React.Children.map(children, child =>
      React.isValidElement(child)
        ? React.cloneElement(child, {
            // Estilos para o SVG filho
            className: cn('h-5 w-5', child.props.className)
          })
        : child
    )}
  </div>
));
DisclaimerIcon.displayName = 'DisclaimerIcon';

const DisclaimerContent = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('flex w-0 flex-1 flex-col', className)}
    {...props}
  />
));
DisclaimerContent.displayName = 'DisclaimerContent';

const DisclaimerText = React.forwardRef(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn('mb-0 w-full truncate text-sm font-light leading-tight text-danger', className)}
    {...props}
  />
));
DisclaimerText.displayName = 'DisclaimerText';

const DisclaimerWrapper = React.forwardRef(({ className, children, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'mb-10 flex items-center',
      // Classes customizadas para a paginação do Swiper
      '[&_.swiper]:w-full [&_.swiper]:max-w-full',
      '[&_.swiper-pagination]:!bottom-0',
      '[&_.swiper-pagination_.swiper-pagination-bullet]:bg-primary-lightest',
      '[&_.swiper-pagination_.swiper-pagination-bullet]:opacity-100',
      '[&_.swiper-pagination_.swiper-pagination-bullet.swiper-pagination-bullet-active]:bg-primary',
      className
    )}
    {...props}
  >
    {children}
  </div>
));
DisclaimerWrapper.displayName = 'DisclaimerWrapper';

export { Disclaimer, DisclaimerTitle, DisclaimerIcon, DisclaimerContent, DisclaimerText, DisclaimerWrapper };
